import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';

export const Logout = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState?.isAuthenticated) { 
        return;
    }

    const originalUri = toRelativeUrl(window.location.href, window.location.origin);
    oktaAuth.setOriginalUri(originalUri);

    oktaAuth.signOut({
        clearTokensBeforeRedirect: true
    });
  }, [oktaAuth, authState, authState?.isAuthenticated]);

  return (<Outlet />);
}
